import { IEventData } from 'meta/pages/v4/event'
import { ILocationData } from 'meta/pages/v4/location'
import { IWalletEvent } from 'meta/pages/v4/wallet'

import { useEventData } from 'hooks/useEvent'
import { useLocationData } from 'hooks/useLocation'

import { WalletTicketMobileSkeleton } from '../../WalletTickets/WalletTicketMobile'
import WalletExtraMobile from './WalletExtraMobile'

type EventProps = {
  isPastEvent?: boolean
  isUsable?: boolean
  walletEventData: IWalletEvent
  onClick: (eventId: number) => void
  setIsThereAtLeastOne?(isThereAtLeastOne: boolean): void
  useLongCard: boolean
  eventActive: number
}

type LocationProps = {
  baseProps: EventProps
  eventData: IEventData
}

export type WalletExtraMobileProps = {
  baseProps: EventProps
  eventData: IEventData
  locationData: ILocationData
}

const WalletExtraMobileContainer: React.FC<EventProps> = (props) => {
  const { walletEventData } = props

  const eventData = useEventData({ idOrCodeUrl: String(walletEventData.id) })

  if (!eventData) {
    return <WalletTicketMobileSkeleton />
  }

  return <LocationContainer eventData={eventData} baseProps={props} />
}

const LocationContainer: React.FC<LocationProps> = (props) => {
  const { baseProps, eventData } = props

  const locationData = useLocationData({ idOrCodeUrl: String(eventData.locationId) })

  if (!locationData) {
    return <WalletTicketMobileSkeleton />
  }

  return <WalletExtraMobile eventData={eventData} locationData={locationData} baseProps={baseProps} />
}

export default WalletExtraMobileContainer
